import { createAction, props } from '@ngrx/store';
import { Details } from '@details/Interfaces/details';

const tag = '[Creditor Details]';

export const loadDetails = createAction(
  `${tag} Load`,
  props<{
    widgetConfigId: number,
    creditorUri: number,
    widgetId: number,
    entityType: string;
  }>());


export const loadDetailsComplete = createAction(
  `${tag} Load Complete`,
  props<{
    details: Details,
    widgetConfigId: number,
    widgetId: number;
  }>());
